(function ($) {
  $.fn.lnswitcher = function () {
    const parent = this;

    const options = $.extend({
      onSelect(val) {}
    }, arguments[0] || {});

    $(this).find('dt a').click((e) => {
      $(parent).find('dd ul').toggle();

      e.preventDefault();
    });

    $(this).find('dd ul li a').click(function (e) {
      const text = $(this).html();
      $(parent).find('dt a span').html(text);
      $(parent).find('dd ul').hide();

      options.onSelect.call(this, $(this).find('span.value').text());

      e.preventDefault();
    });

    $(document).bind('click', (e) => {
      const $clicked = $(e.target);
      if (!$clicked.parents().hasClass('dropdown')) $(parent).find('dd ul').hide();
    });

    $(this).find('dd ul li').each(function (index) {
      if ($(this).hasClass('active')) {
        const text = $(this).find('a').html();
        $(parent).find('dt a span').html(text);
        $(parent).find('dd ul').hide();
      }
    });
  };
}(jQuery));
